var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLargeLayoutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    opacity: 0.713
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E9EBED",
    d: "M0 0h18v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#003346",
    strokeWidth: 2.333,
    d: "M1.166 1.166h15.667v21.667H1.166z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#003346",
    d: "M2.095 4.81h13.81v14.275H2.095z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeLayoutIcon);
export default __webpack_public_path__ + "static/media/LargeLayoutIcon.1854c4d8722f68b1ee6b6fdaffa0ee6b.svg";
export { ForwardRef as ReactComponent };